var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReserved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grid",
    display: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "menu"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "fried_egg"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "food_tray"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "fried_chicken"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ham"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "chef_hat"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "bill"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "soft_drink"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "best_quality"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "wine_glass"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "restaurant"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "serve"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "placeholder"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "pot"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "french_fries"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "soup"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "meat"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "ramen"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "bread"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "coffee"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "order_list"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "food_order"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "reserved"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.974 13.465-4.551 3.666-1.504-1.92c-.307-.391-.872-.46-1.264-.152-.391.307-.46.872-.153 1.264l2.067 2.637c.148.189.367.312.606.339.034.004.068.006.102.006.205 0 .404-.07.564-.199l5.261-4.237c.387-.313.448-.879.137-1.266-.31-.386-.878-.451-1.265-.138z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.843 22.342-3.121-13.695c-.238-1.041-1.149-1.769-2.218-1.769h-19.029c-.049 0-.096.012-.144.016-.994.074-1.825.77-2.049 1.754l-3.124 13.692c-.155.679.005 1.38.439 1.923.434.544 1.082.856 1.777.856h2.091c.497 0 .9-.403.9-.9s-.403-.9-.9-.9h-2.091c-.199 0-.317-.111-.37-.178-.053-.066-.135-.207-.091-.4l2.489-10.907 2.626 11.519c.237 1.041 1.149 1.769 2.216 1.769h18.382c.696 0 1.344-.313 1.777-.856.434-.544.594-1.245.44-1.924zm-1.847.801c-.053.066-.172.178-.37.178h-18.382c-.222 0-.412-.151-.461-.368l-3.306-14.264c.008 0 .013-.007.021-.007h9.021c.003 0 .006-.002.01-.002h9.975c.223 0 .413.151.462.368l3.121 13.694c.045.194-.038.334-.091.401z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "taco"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "sausage"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserved);
export default __webpack_public_path__ + "static/media/reserved.cf0170313945c2d4602595745d008751.svg";
export { ForwardRef as ReactComponent };